import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { useRetailSales } from "./hooks/useRetailSales";
import Header from "../../../components/Header";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "retailSalesReport.info.title",
  rows: [
    "retailSalesReport.info.clinicRetailSales",
    "retailSalesReport.info.providerRetailSales",
  ],
};

const RetailSales = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useRetailSales(requestParams);

  const isClinicDataEmpty = !isLoading && !data?.clinicRetailSales?.length;
  const isProviderDataEmpty = !isLoading && !data?.providerRetailSales?.length;

  const clinicData = useMemo(
    () =>
      data?.clinicRetailSales.map((clinic) => ({
        clinicName: clinic.clinic_name,
        retailSales: clinic.retail_sales,
      })),
    [data],
  );

  const providerData = useMemo(
    () =>
      data?.providerRetailSales.map((provider) => ({
        providerName: provider.provider,
        providerTotalSales: provider.retail_sales,
      })),
    [data],
  );

  const clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Retail Sales"
        selectedClinic={selectedClinic}
        clinics={clinics}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getRetailSales()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Clinic Name", accessor: "clinicName" },
              { data: "Retail Sales", accessor: "retailSales" },
            ]}
            data={clinicData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isClinicDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Provider Name", accessor: "providerName" },
              { data: "Retail Sales", accessor: "providerTotalSales" },
            ]}
            data={providerData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isProviderDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default RetailSales;
